module.exports = __webpack_public_path__ + "static/media/ApiceFechamento.ef335803.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/ApiceFechamento.png
// module id = 187
// module chunks = 0